import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import {
  extensionsType,
  pdfErrors,
  uploadPdf,
  validFormatTypes,
} from '../constants'

interface BulkRegistrationDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (formData: FormData) => void
}

const BulkRegistrationDialog: React.FC<BulkRegistrationDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState('')

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0]
    if (selectedFile) {
      const validTypes = [
        validFormatTypes?.application,
        validFormatTypes?.excel,
        validFormatTypes?.xml,
        validFormatTypes?.xlms,
      ]

      const fileExtension = selectedFile.name.split('.').pop()?.toLowerCase()

      if (
        !validTypes.includes(selectedFile.type) &&
        !extensionsType.includes(`.${fileExtension}`)
      ) {
        setError(pdfErrors.allowedError)
        setFile(null)
      } else {
        setError('')
        setFile(selectedFile)
      }
    }
  }

  const handleSubmit = () => {
    if (!file) {
      setError(pdfErrors.validPdf)
      return
    }
    const formData = new FormData()
    formData.append('file', file, file.name)
    onSubmit(formData)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Import</DialogTitle>
      <DialogContent>
        <Typography variant='body2' gutterBottom>
          {uploadPdf}
        </Typography>
        <input
          type='file'
          accept='.pdf,.xls,.xlsx'
          onChange={handleFileChange}
          style={{ marginTop: '10px' }}
          data-testid='file-input'
        />
        {error && (
          <Typography color='error' variant='body2' marginTop={1}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant='contained' disabled={!file}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BulkRegistrationDialog
